import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import DocumentUploader from 'modules/documents/components/Documents/DocumentUploader'
import JobRole from 'modules/job_catalog/store/models/JobRole'

const Component = () => {
  const { value: canCreateJob } = useAsyncCan('job_catalog.create_job')

  return (
    <AuthorizeUser authorizeFn={() => canCreateJob}>
      <ImportJobsModalPage />
    </AuthorizeUser>
  )
}

const ImportJobsModalPage = observer(() => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const form = useRef(new Form({ file: null }, { file: 'file' })).current
  const onClose = () => navigate(navigation.employees.jobCatalog.list.fullPath())
  const handleSubmit = () => {
    const file = form.get('file').value
    navigate(navigation.employees.jobCatalog.list.fullPath(), { state: { file } })
  }

  return (
    <Modal
      illustration="group"
      title={i18n.t('job_catalog.import_jobs_modal_title')}
      description={i18n.t('job_catalog.import_jobs_modal_description')}
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={!form.isComplete} submit>
            {i18n.t('import.process_file')}
          </Button>
        </>
      }
    >
      <Box paddingBottom="s24" alignItems="center">
        <Button.Router to={buildUrl(`${JobRole.importUrl()}/new`)} type="secondary" download>
          {i18n.t('job_catalog.import_jobs_download_template')}
        </Button.Router>
      </Box>
      <Box gap="s24">
        <DocumentUploader
          accept={{
            ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']: ['.xlsx'],
          }}
          field={form.get('file')}
          placeholder={i18n.t('job_catalog.import_jobs_drag_and_drop')}
        />

        <Alert color="warning">
          <Text.Normal>{i18n.t('job_catalog.import_jobs_modal_note')}</Text.Normal>
        </Alert>
      </Box>
    </Modal>
  )
})

export default Component
